import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import {
  setExternalSearch,
  setFilterSectionIsCollapsed,
  setView,
} from 'actions/search';
import { format } from 'utils/date';
import { useAuth, useDefaultCategories } from 'hooks';

const TradeshowSearchRedirect = () => {
  const dispatch = useDispatch();
  const { replace } = useHistory();
  const { search } = useLocation();
  const { hasLicense } = useAuth();
  const searchCategories = useDefaultCategories();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const name = params.get('name');
    const date = params.get('date');

    if (name) {
      dispatch(setView('researcher'));
      dispatch(
        setExternalSearch({
          term: '*',
          tradeshow: [
            {
              label: date ? `${name} - ${format(date, 'YYYY')}` : name,
              date,
            },
          ],
          // Same payload as the calendar's View Contacts button; thisShowOnly only matches tradeshow items.
          category: { ...searchCategories, tradeshows: true },
          date: 'all',
          thisShowOnly: true,
        })
      );
      dispatch(setFilterSectionIsCollapsed('tradeshows', false));
    }

    replace('/');
  }, [dispatch, hasLicense, replace, search, searchCategories]);

  return null;
};

export default TradeshowSearchRedirect;
